import React from 'react';
import { Navigate } from 'react-router-dom';

const PublicRoute = ({ isAuthenticated, children }) => {
  // If the user is authenticated, redirect them to the dashboard
  return !isAuthenticated ? children : <Navigate to="/dashboard" />;
};

export default PublicRoute;
